export const quickActions = {
  en: {
    // Header
    title: 'Quick Actions',
    
    // Menu Items
    myProgress: 'My Progress',
    myProgressSubtitle: 'View stats and achievements',
    settings: 'Settings',
    settingsSubtitle: 'App preferences',
    signOut: 'Sign Out',
    signOutSubtitle: 'Log out of your account',
    
    // Sign Out Dialog
    signOutTitle: 'Sign Out',
    signOutMessage: 'Are you sure you want to sign out?',
    cancel: 'Cancel',
    signOutConfirm: 'Sign Out',
    
    // Error Messages
    signOutError: 'Failed to sign out. Please try again.',
    error: 'Error',

    // Guest User Messages
    notSignedIn: 'Not Signed In',
    guestNoAccount: 'You are playing as a guest. Sign in to create an account and save your progress.',
    ok: 'OK',
  },
  
  es: {
    // Header
    title: 'Acciones Rápidas',

    // Menu Items
    myProgress: 'Mi Progreso',
    myProgressSubtitle: 'Ver estadísticas y logros',
    settings: 'Configuración',
    settingsSubtitle: 'Preferencias de la aplicación',
    signOut: 'Cerrar Sesión',
    signOutSubtitle: 'Salir de tu cuenta',

    // Sign Out Dialog
    signOutTitle: 'Cerrar Sesión',
    signOutMessage: '¿Estás seguro de que quieres cerrar sesión?',
    cancel: 'Cancelar',
    signOutConfirm: 'Cerrar Sesión',

    // Error Messages
    signOutError: 'Error al cerrar sesión. Por favor, inténtalo de nuevo.',
    error: 'Error',

    // Guest User Messages
    notSignedIn: 'No has iniciado sesión',
    guestNoAccount: 'Estás jugando como invitado. Inicia sesión para crear una cuenta y guardar tu progreso.',
    ok: 'OK',
  },
  
  fr: {
    // Header
    title: 'Actions Rapides',

    // Menu Items
    myProgress: 'Mon Progrès',
    myProgressSubtitle: 'Voir les statistiques et réalisations',
    settings: 'Paramètres',
    settingsSubtitle: 'Préférences de l\'application',
    signOut: 'Se Déconnecter',
    signOutSubtitle: 'Se déconnecter de votre compte',

    // Sign Out Dialog
    signOutTitle: 'Se Déconnecter',
    signOutMessage: 'Êtes-vous sûr de vouloir vous déconnecter?',
    cancel: 'Annuler',
    signOutConfirm: 'Se Déconnecter',

    // Error Messages
    signOutError: 'Échec de la déconnexion. Veuillez réessayer.',
    error: 'Erreur',

    // Guest User Messages
    notSignedIn: 'Non connecté',
    guestNoAccount: 'Vous jouez en tant qu\'invité. Connectez-vous pour créer un compte et sauvegarder votre progression.',
    ok: 'OK',
  },
  
  de: {
    // Header
    title: 'Schnellaktionen',

    // Menu Items
    myProgress: 'Mein Fortschritt',
    myProgressSubtitle: 'Statistiken und Erfolge anzeigen',
    settings: 'Einstellungen',
    settingsSubtitle: 'App-Einstellungen',
    signOut: 'Abmelden',
    signOutSubtitle: 'Von Ihrem Konto abmelden',

    // Sign Out Dialog
    signOutTitle: 'Abmelden',
    signOutMessage: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    cancel: 'Abbrechen',
    signOutConfirm: 'Abmelden',

    // Error Messages
    signOutError: 'Abmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    error: 'Fehler',

    // Guest User Messages
    notSignedIn: 'Nicht angemeldet',
    guestNoAccount: 'Sie spielen als Gast. Melden Sie sich an, um ein Konto zu erstellen und Ihren Fortschritt zu speichern.',
    ok: 'OK',
  },
  
  pt: {
    // Header
    title: 'Ações Rápidas',

    // Menu Items
    myProgress: 'Meu Progresso',
    myProgressSubtitle: 'Ver estatísticas e conquistas',
    settings: 'Configurações',
    settingsSubtitle: 'Preferências do aplicativo',
    signOut: 'Sair',
    signOutSubtitle: 'Sair da sua conta',

    // Sign Out Dialog
    signOutTitle: 'Sair',
    signOutMessage: 'Tem certeza de que deseja sair?',
    cancel: 'Cancelar',
    signOutConfirm: 'Sair',

    // Error Messages
    signOutError: 'Falha ao sair. Tente novamente.',
    error: 'Erro',

    // Guest User Messages
    notSignedIn: 'Não conectado',
    guestNoAccount: 'Você está jogando como convidado. Entre para criar uma conta e salvar seu progresso.',
    ok: 'OK',
  },
  
  ru: {
    // Header
    title: 'Быстрые Действия',

    // Menu Items
    myProgress: 'Мой Прогресс',
    myProgressSubtitle: 'Просмотр статистики и достижений',
    settings: 'Настройки',
    settingsSubtitle: 'Настройки приложения',
    signOut: 'Выйти',
    signOutSubtitle: 'Выйти из аккаунта',

    // Sign Out Dialog
    signOutTitle: 'Выйти',
    signOutMessage: 'Вы уверены, что хотите выйти?',
    cancel: 'Отмена',
    signOutConfirm: 'Выйти',

    // Error Messages
    signOutError: 'Не удалось выйти. Попробуйте еще раз.',
    error: 'Ошибка',

    // Guest User Messages
    notSignedIn: 'Не вошли в систему',
    guestNoAccount: 'Вы играете как гость. Войдите, чтобы создать аккаунт и сохранить свой прогресс.',
    ok: 'ОК',
  },
  
  tl: {
    // Header
    title: 'Mga Mabilis na Aksyon',

    // Menu Items
    myProgress: 'Aking Pag-unlad',
    myProgressSubtitle: 'Tingnan ang mga stats at achievements',
    settings: 'Mga Setting',
    settingsSubtitle: 'Mga preference ng app',
    signOut: 'Mag-sign Out',
    signOutSubtitle: 'Mag-log out sa inyong account',

    // Sign Out Dialog
    signOutTitle: 'Mag-sign Out',
    signOutMessage: 'Sigurado ba kayong gusto ninyong mag-sign out?',
    cancel: 'Kanselahin',
    signOutConfirm: 'Mag-sign Out',

    // Error Messages
    signOutError: 'Hindi naka-sign out. Subukan ulit.',
    error: 'Error',

    // Guest User Messages
    notSignedIn: 'Hindi naka-sign in',
    guestNoAccount: 'Naglalaro ka bilang bisita. Mag-sign in para lumikha ng account at i-save ang iyong progress.',
    ok: 'OK',
  },
  
  it: {
    // Header
    title: 'Azioni Rapide',

    // Menu Items
    myProgress: 'I Miei Progressi',
    myProgressSubtitle: 'Visualizza statistiche e traguardi',
    settings: 'Impostazioni',
    settingsSubtitle: 'Preferenze dell\'app',
    signOut: 'Disconnetti',
    signOutSubtitle: 'Disconnettiti dal tuo account',

    // Sign Out Dialog
    signOutTitle: 'Disconnetti',
    signOutMessage: 'Sei sicuro di voler disconnetterti?',
    cancel: 'Annulla',
    signOutConfirm: 'Disconnetti',

    // Error Messages
    signOutError: 'Disconnessione fallita. Riprova.',
    error: 'Errore',

    // Guest User Messages
    notSignedIn: 'Non connesso',
    guestNoAccount: 'Stai giocando come ospite. Accedi per creare un account e salvare i tuoi progressi.',
    ok: 'OK',
  },
  
  am: {
    // Header
    title: 'ፈጣን ተግባራት',

    // Menu Items
    myProgress: 'የእኔ እድገት',
    myProgressSubtitle: 'ስታቲስቲክስ እና ስኬቶችን ይመልከቱ',
    settings: 'ቅንጅቶች',
    settingsSubtitle: 'የመተግበሪያ ምርጫዎች',
    signOut: 'ውጣ',
    signOutSubtitle: 'ከመለያዎ ይውጡ',

    // Sign Out Dialog
    signOutTitle: 'ውጣ',
    signOutMessage: 'እርግጠኛ ነዎት መውጣት ይፈልጋሉ?',
    cancel: 'ሰርዝ',
    signOutConfirm: 'ውጣ',

    // Error Messages
    signOutError: 'መውጣት አልተቻለም። እንደገና ይሞክሩ።',
    error: 'ስህተት',

    // Guest User Messages
    notSignedIn: 'ገብተው አይደሉም',
    guestNoAccount: 'እንግዳ ሆነው እየተጫወቱ ነው። መለያ ለመፍጠር እና እድገትዎን ለማስቀመጥ ይግቡ።',
    ok: 'እሺ',
  },
  
  ko: {
    // Header
    title: '빠른 작업',

    // Menu Items
    myProgress: '내 진도',
    myProgressSubtitle: '통계 및 성취 보기',
    settings: '설정',
    settingsSubtitle: '앱 설정',
    signOut: '로그아웃',
    signOutSubtitle: '계정에서 로그아웃',

    // Sign Out Dialog
    signOutTitle: '로그아웃',
    signOutMessage: '정말 로그아웃하시겠습니까?',
    cancel: '취소',
    signOutConfirm: '로그아웃',

    // Error Messages
    signOutError: '로그아웃에 실패했습니다. 다시 시도해주세요.',
    error: '오류',

    // Guest User Messages
    notSignedIn: '로그인하지 않음',
    guestNoAccount: '게스트로 플레이 중입니다. 로그인하여 계정을 만들고 진행 상황을 저장하세요.',
    ok: '확인',
  },
};